import { classNames } from "@helpers/css";
import { titleCase } from "@helpers/string";

import {
  defaultIcon,
  dimensionIcons,
  statusBadge,
  statusDot,
} from "./coaching-constants";
import type { Status } from "./coaching-constants";

export const StatusBadge = ({
  status,
  label,
}: {
  status: Status;
  label: string;
}) => (
  <span
    className={classNames(
      "inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset whitespace-nowrap",
      statusBadge[status],
    )}
  >
    <span
      className={classNames("h-1.5 w-1.5 rounded-full", statusDot[status])}
    />
    {titleCase(label)}
  </span>
);

export const DimensionIcon = ({
  name,
  className,
}: {
  name: string;
  className?: string;
}) => {
  const Icon = dimensionIcons[name] || defaultIcon;
  return <Icon className={className} />;
};
